const Links = function (restClient) {
  this.restClient = restClient
}

Links.prototype.getShortUrl = async function (eventId, url) {
  return await this.restClient.post('/links/shortenUrl', { eventId, url })
}

export default Links
